import { lazy } from 'react';
import RequireAdmin from 'domain/auth/components/RequireAdminRole';
import {
  RouteParams,
  RoutesPath,
  AdminSubRoutesPath,
  SellingToolsSubRoutesPath,
  CompanyItemSubRoutesPath,
  ClientsItemSubRoutesPath,
} from 'router/routesPaths';

const HomePage = lazy(() => import('domain/home/components/HomePage'));
const MyCompanyPage = lazy(() => import('domain/company/components/MyCompanyPage'));
const SupportPage = lazy(() => import('domain/support/components/SupportPage'));
const SellingToolsPage = lazy(() => import('domain/sellingTools/components/SellingToolsPage'));
const MyClientsPage = lazy(() => import('domain/myClients/components/MyClientsPage'));
const CalendarPage = lazy(() => import('domain/calendar/components/CalendarPage'));
const NewsArticleAdminPage = lazy(() => import('domain/home/components/admin/NewsArticleAdminPage'));
const AdminPage = lazy(() => import('domain/admin/components/AdminPage'));
const CalendarEventAdminPage = lazy(() => import('domain/calendar/components/admin/CalendarEventAdminPage'));
const ProfilePage = lazy(() => import('domain/profile/components/ProfilePage'));
const AlertAdminPage = lazy(() => import('domain/alert/components/AlertAdminPage'));
const EquisoftPage = lazy(() => import('domain/equisoft/component/EquisoftPage'));
const BlockedTransaction = lazy(() => import('domain/admin/blockedTransaction/BlockedTransaction'));
const UniqueQuizPage = lazy(() => import('domain/company/components/ufcCenter/UniqueQuizPage'));
const AdvisorReportsPage = lazy(() => import('domain/advisorReports/components/AdvisorReportsPage'));
const PromotionsPage = lazy(() => import('domain/calendar/components/PromotionsPage'));
const DocumentItemDetailPage = lazy(() => import('domain/sellingTools/components/DocumentItemDetailPage'));
const SearchPage = lazy(() => import('domain/searchPage/components/SearchPage'));

const sellingToolsSubRoutes = Object.values(SellingToolsSubRoutesPath).map(path => ({
  path,
  Element: DocumentItemDetailPage,
}));

const companyItemSubRoutesPath = [
  ...Object.values(CompanyItemSubRoutesPath).map(path => ({
    path,
    Element: DocumentItemDetailPage,
  })),
  {
    path: `${CompanyItemSubRoutesPath.CONTRACT_MANAGEMENT}/advisorReports`,
    Element: AdvisorReportsPage,
  },
];

const clientsItemSubRoutesPath = Object.values(ClientsItemSubRoutesPath).map(path => ({
  path,
  Element: DocumentItemDetailPage,
}));

const adminSubRoutes: RouteParams[] = [
  {
    path: AdminSubRoutesPath.NEWS,
    Element: () => (
      <RequireAdmin>
        <NewsArticleAdminPage />
      </RequireAdmin>
    ),
  },
  {
    path: AdminSubRoutesPath.CALENDAR,
    Element: () => (
      <RequireAdmin>
        <CalendarEventAdminPage />
      </RequireAdmin>
    ),
  },
  {
    path: AdminSubRoutesPath.ALERTS,
    Element: () => (
      <RequireAdmin>
        <AlertAdminPage />
      </RequireAdmin>
    ),
  },
  {
    path: AdminSubRoutesPath.BLOCKED_TRANSACTIONS,
    Element: () => (
      <RequireAdmin>
        <BlockedTransaction />
      </RequireAdmin>
    ),
  },
];

const rootRoutes: RouteParams[] = [
  {
    path: RoutesPath.HOME,
    Element: HomePage,
    index: true,
  },
  {
    path: RoutesPath.MY_CLIENTS,
    Element: MyClientsPage,
    children: clientsItemSubRoutesPath,
  },
  {
    path: RoutesPath.SELLING_TOOLS,
    Element: SellingToolsPage,
    children: sellingToolsSubRoutes,
  },
  {
    path: RoutesPath.MY_COMPANY,
    Element: MyCompanyPage,
    children: companyItemSubRoutesPath,
  },
  {
    path: RoutesPath.UNIQUE_UFC_QUIZ,
    Element: UniqueQuizPage,
  },
  {
    path: RoutesPath.SUPPORT,
    Element: SupportPage,
  },
  {
    path: RoutesPath.CALENDAR,
    Element: CalendarPage,
  },
  {
    path: RoutesPath.PROMOTIONS,
    Element: PromotionsPage,
  },
  {
    path: RoutesPath.ADMIN,
    Element: () => (
      <RequireAdmin>
        <AdminPage />
      </RequireAdmin>
    ),
    children: adminSubRoutes,
  },
  {
    path: RoutesPath.PROFIL,
    Element: ProfilePage,
  },
  {
    path: RoutesPath.EQUISOFT,
    Element: EquisoftPage,
  },
  {
    path: RoutesPath.SEARCH,
    Element: SearchPage,
  },
];

export default rootRoutes;
